import { createSlice } from '@reduxjs/toolkit';
import { fetchMostViewedArticles } from '../actions/fetchMostViewedArticles';
import { fetchArticleCategories } from '../actions/fetchArticleCategories';
import { fetchCategoryArticles } from '../actions/fetchCategoryArticles';
import { UNINITIALIZED, PENDING, SUCCEEDED, FAILED } from 'conversations-internal-schema/constants/RequestStatusTypes';
const initialState = {
  mostViewedArticles: [],
  articleCategories: [],
  selectedCategory: {
    name: '',
    id: -1,
    articles: []
  },
  requestStatus: {
    mostViewedArticles: UNINITIALIZED,
    articleCategories: UNINITIALIZED,
    selectedCategoryArticles: UNINITIALIZED
  }
};
const kbLibrarySlice = createSlice({
  name: 'kbLibrary',
  initialState,
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory.name = action.payload.name;
      state.selectedCategory.id = action.payload.id;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchMostViewedArticles.pending, state => {
      state.requestStatus.mostViewedArticles = PENDING;
    }).addCase(fetchMostViewedArticles.fulfilled, (state, action) => {
      state.requestStatus.mostViewedArticles = SUCCEEDED;
      state.mostViewedArticles = action.payload;
    }).addCase(fetchMostViewedArticles.rejected, state => {
      state.requestStatus.mostViewedArticles = FAILED;
    }).addCase(fetchArticleCategories.pending, state => {
      state.requestStatus.articleCategories = PENDING;
    }).addCase(fetchArticleCategories.fulfilled, (state, action) => {
      state.requestStatus.articleCategories = SUCCEEDED;
      state.articleCategories = action.payload;
    }).addCase(fetchArticleCategories.rejected, state => {
      state.requestStatus.articleCategories = FAILED;
    }).addCase(fetchCategoryArticles.pending, state => {
      state.requestStatus.selectedCategoryArticles = PENDING;
    }).addCase(fetchCategoryArticles.fulfilled, (state, action) => {
      state.requestStatus.selectedCategoryArticles = SUCCEEDED;
      state.selectedCategory.articles = action.payload;
    }).addCase(fetchCategoryArticles.rejected, state => {
      state.requestStatus.selectedCategoryArticles = FAILED;
    });
  }
});
export const {
  setSelectedCategory
} = kbLibrarySlice.actions;
export default kbLibrarySlice.reducer;